import { render } from "./SettingsTrajectory.vue?vue&type=template&id=67e14686"
import script from "./SettingsTrajectory.vue?vue&type=script&lang=js"
export * from "./SettingsTrajectory.vue?vue&type=script&lang=js"

import "./SettingsTrajectory.vue?vue&type=style&index=0&id=67e14686&lang=css"
script.render = render

export default script